import type { FC } from "react";

import * as CSS from "./progress-bar.styles";

type ProgressBarProps = {
	percentage: number;
};

const ProgressBar: FC<ProgressBarProps> = ({ percentage }) => {
	return (
		<CSS.ProgressBar>
			<CSS.Track />
			<CSS.Progress $width={`${percentage}%`} />
		</CSS.ProgressBar>
	);
};

export default ProgressBar;
